var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dt-display"},[_c('div',{staticClass:"dt-date"},[_vm._v(_vm._s(_vm.formattedDate))]),_c('div',{staticClass:"dt-time"},[_vm._v(_vm._s(_vm.formattedTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }